import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { Api } from '../axiosApi';

// Mesma conta fixa do backend (ContasRecebiveisFixas.ts) — todo boleto
// baixado em Contas a Receber cai aqui até ser compensado de verdade.
export const CONTA_RECEBIVEL_BOLETO_IDCONTA = '73fc4bbf-63de-4306-9a78-523522c2aacc';

export type TStatusBoletoReceber = 'A_COMPENSAR' | 'COMPENSADO' | 'ESTORNADO';

export interface IListagemBoletoReceber {
  idboletoreceber: string;
  idrec: string | null;
  parceironome: string;
  numerocr: string;
  parcela: string | null;
  datapagamento: Date;
  datacompensacaoprevista: string;
  datacompensacaoefetiva: Date | null;
  valorbruto: number;
  tarifa: number;
  valorliquido: number;
  status: TStatusBoletoReceber;
  descricao: string;
}

type TotalCount = {
  data: IListagemBoletoReceber[];
  totalCount: number;
};

export interface ICompensarBoletos {
  ids: string[];
  idcontadestino: string;
  valorliquido: number;
  datalan: Date;
}

export interface IResultadoCompensarBoletos {
  ids: string[];
  valorBruto: number;
  valorLiquido: number;
  taxa: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const tratarErro = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response) {
      return new Error(axiosError.response.data.errors?.default || 'Erro desconhecido');
    } else if (axiosError.request) {
      return new Error('Nenhuma resposta do servidor');
    }
    return new Error(axiosError.message);
  }
  return new Error('Erro inesperado');
};

const getAll = async (
  // 'ATRASADO' é um filtro derivado (não um status real gravado) — pega os
  // A_COMPENSAR cuja data prevista de compensação já passou (ver GetAll.ts,
  // backend).
  status: 'todos' | TStatusBoletoReceber | 'ATRASADO' = 'todos',
  datainicial = '',
  datafinal = '',
  page = 1,
): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/boletosreceber?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&status=${status}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 0),
      };
    }
    return new Error('Erro ao listar os boletos a receber.');
  } catch (error) {
    return tratarErro(error);
  }
};

const compensar = async (dados: ICompensarBoletos): Promise<IResultadoCompensarBoletos | Error> => {
  try {
    const { data } = await Api.post<IResultadoCompensarBoletos>('/boletosreceber/compensar', dados);
    return data;
  } catch (error) {
    return tratarErro(error);
  }
};

export const BoletosReceberService = {
  getAll,
  compensar,
};
